import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  
  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: 0 16px;
  }
`;